export function encodeFromBase64(str) {
  return btoa(str) 
    .replace(/\+/g, '-') 
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function decodeFromBase64(encoded) {
  encoded = encoded
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  return atob(encoded);
}